import { Injectable, inject } from '@angular/core';
import {
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  CanActivateFn,
} from '@angular/router';
import {
  AuthService,
  RoutingService,
  CmsService,
  ProtectedRoutesGuard,
  RoutingConfigService,
  User,
} from '@spartacus/core';
import { CommonService } from '../services/common.service';
import { Observable, of } from 'rxjs';
import { switchMap, first, take, tap } from 'rxjs/operators';
import { UserRoleService } from '../services/user-role.service';

@Injectable({ providedIn: 'root' })
export class UserRoleGuardClass {
  user$: Observable<User>;
  userType = '';

  constructor(
    protected authService: AuthService,
    private router: Router,
    private commonService: CommonService,
    protected routingService: RoutingService,
    protected cmsService: CmsService,
    protected protectedRoutesGuard: ProtectedRoutesGuard,
    protected routingConfig: RoutingConfigService,
    private userRoleService: UserRoleService

  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.protectedRoutesGuard.canActivate(route).pipe(
      switchMap((canActivate) =>
        canActivate
          ? this.routingService.getNextPageContext().pipe(
              switchMap((pageContext) =>
                this.cmsService.getPage(pageContext).pipe(
                  first(),
                  switchMap((pageData) =>
                    this.authService.isUserLoggedIn().pipe(
                      first(),
                      take(1),
                      switchMap((isLoggedIn) =>
                        this.getUserRoleAccess(isLoggedIn, pageData)
                      )
                    )
                  )
                )
              )
            )
          : of(false)
      ),
      tap((val) => {
        if (!val) {
          this.router.navigate(['/access-denied']);
        }
      })
    );
  }

  getUserRoleAccess(isLoggedIn, pageData): Observable<any> {
    if (pageData) {
      const userType = isLoggedIn ? 'current' : 'anonymous';
      const urlParams = ['users', userType, 'roleAccessCheck'];
      const apiUrl =
        this.commonService.constructUrl(urlParams) +
        '?pageId=' +
        pageData.pageId;
      return this.commonService.getData_WithoutRetry(apiUrl).pipe(
        switchMap((res: any) => {
          this.userRoleService.userRoleInfo.next(res);
          return res?.pageAccessFlag ? of(true) : of(false);
        })
      );
    }
  }
}
export const UserRoleGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  return inject(UserRoleGuardClass).canActivate(route, state)
}
